// extracted by mini-css-extract-plugin
export default {"rootDiv":"style_rootDiv__lESL0","person":"style_person__gsG97","loginBox":"style_loginBox__4cOZq","inputBox":"style_inputBox__YMOeL","loginBtn":"style_loginBtn__SBWzl"};